export type NotificationType =
  | 'ACTIVITY_LOGGED'
  | 'TEAM_CHAT'
  | 'TEAM_BADGE_EARNED'
  | 'GATE_REACHED'
  | 'CHECKPOINT_REACHED'
  | 'HQ'

export interface NotificationArgument {
  id: string
  userId: string
  type: NotificationType
  title: string
  message: string
  data: Record<string, any>
  read: boolean
  createdAt: Date
  sendPush: boolean
}

export default class Notification {
  readonly id: string
  readonly userId: string
  readonly type: NotificationType
  readonly title: string
  readonly message: string
  readonly data: Record<string, any>
  readonly read: boolean
  readonly createdAt: Date
  readonly sendPush: boolean

  constructor(arg: NotificationArgument) {
    this.id = arg.id
    this.userId = arg.userId
    this.type = arg.type
    this.title = arg.title
    this.message = arg.message
    this.data = arg.data
    this.read = arg.read
    this.createdAt = arg.createdAt
    this.sendPush = arg.sendPush
  }

  static fromPG(row: any): Notification {
    return new Notification({
      id: row.id,
      userId: row.user_id,
      type: row.type,
      title: row.title,
      message: row.message,
      data: row.data,
      read: row.read,
      createdAt: new Date(row.created_at),
      sendPush: row.send_push,
    })
  }

  toPG(): any {
    return {
      id: this.id,
      user_id: this.userId,
      type: this.type,
      title: this.title,
      message: this.message,
      data: this.data,
      read: this.read,
      created_at: this.createdAt.toISOString(),
      send_push: this.sendPush,
    }
  }

  markAsRead() {
    return new Notification({
      ...this,
      read: true,
    })
  }
}
